import type { Insurer } from '../../enums'
import type { Part } from './Part'


export interface AdditionBase {
    offerPartId?: number | null
    packageItemId?: number | null
    riskId?: number | null
    insurer?: Insurer | null
    limit?: string | null
    variantId?: number | null
    key?: string | null
    value?: any | null
}

export interface AdditionBicycle extends AdditionBase {
    color?: string | null
    type?: string | null
    bikeType: keyof typeof BikeKinds
    identification?: string | null
    brand?: string | null
    description?: string | null
    version?: string | null
}

export const BikeKinds = {
    Bike: 'Kolo',
    ElectricBike: 'Elektrokolo',
    Scooter: 'Koloběžka',
    ElectricScooter: 'Elektrokoloběžka',
    BikeTrailer: 'Připojný vozík na kolo'
} as const

export type BikeKinds = typeof BikeKinds[keyof typeof BikeKinds]

export interface AdditionPet extends AdditionBase {
    type: keyof typeof PetKinds
    age?: number | null | null
    chipId?: string | null
    name?: string | null
    race?: string | null
}

export const PetKinds = {
    Dog: 'Pes',
    Cat: 'Kočka'
} as const

export type PetKinds = typeof PetKinds[keyof typeof PetKinds]
export interface AdditionMedical extends AdditionBase {
    type?: string | null
    description?: string | null
}

export interface AdditionCycleAssistance extends AdditionBase {
    description: string
}

export interface AdditionIntLimitBase extends AdditionBase {
    key: string
}

export interface AdditionConstructionAssembly extends AdditionIntLimitBase {
    duration: DurationKinds
}

export interface AdditionSportEquipment extends AdditionBase {
    type?: string
    description?: string
}

export interface AdditionSportEquipmentTravel extends AdditionBase {
    description: string
}

export interface AdditionVehicle extends AdditionBase {
    registrationMark: string
}

export interface AdditionPetTravel extends AdditionBase {
    chipId: string
}

export const DurationKinds = {
    OneYear: '1 rok',
    TwoYears: '2 roky',
    ThreeYears: '3 roky'
} as const

export type DurationKinds = typeof DurationKinds[keyof typeof DurationKinds]

export interface AdditionMusicalInstrument extends AdditionBase {
    description: string
}

export interface OfferPropertyAddition extends OfferPackageAddition {
    bicycles: AdditionBicycle[]
    pets: AdditionPet[]
    medicals: AdditionMedical[]
    cycleAssistance: AdditionCycleAssistance[]
    constructionAssemblies: AdditionConstructionAssembly[]
    musicalInstruments: AdditionMusicalInstrument[]
    sportEquipments: AdditionSportEquipment[]
}

export interface OfferTravelAddition extends OfferPackageAddition {
    sportEquipments: AdditionSportEquipmentTravel[]
    vehicles: AdditionVehicle[]
    pets: AdditionPetTravel[]
}

export interface OfferPackageAddition {
    changedParts: { [x: number]: Part }
    changedPackages: { [x: number]: { groupId?: number, packageId?: number } }
}